// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useTrailerTrackingV2DebouncedUpdateDraftParameter,
    useTrailerTrackingV2State,
} from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface TrailerTrackingV2FilterFieldTrailerIdProps {}

export interface TrailerTrackingV2FilterFieldTrailerIdStyles {
    textField?: TextFieldPresentationProps;
}

export const trailerTrackingV2FilterFieldTrailerIdStyles: TrailerTrackingV2FilterFieldTrailerIdStyles = {
    textField: filterDrawerProps.textField,
};

const styles = trailerTrackingV2FilterFieldTrailerIdStyles;

const TrailerTrackingV2FilterFieldTrailerId: FC<TrailerTrackingV2FilterFieldTrailerIdProps> = () => {
    const { trailerId } = useTrailerTrackingV2State().draftParameter;
    const debouncedUpdateDraftParameter = useTrailerTrackingV2DebouncedUpdateDraftParameter();
    const [value, setValue] = useState(trailerId);
    const id = useMemo(uniqueId, []);

    useEffect(() => {
        if (value !== trailerId) {
            setValue(trailerId);
        }
    }, [trailerId]);

    return (
        <FilterDrawerSection title={translate("Trailer ID")} labelFor={id}>
            <TextField
                {...styles.textField}
                id={id}
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ trailerId: event.currentTarget.value });
                }}
                placeholder={translate("Enter Trailer ID")}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default TrailerTrackingV2FilterFieldTrailerId;
